import React from 'react';
import {
    OVERLAP_TAB_CONFIG,
    OverlapRow,
    OverlapTabConfig,
    counterpartTotal,
    formatAmountInUnit,
    parseINR,
    scaleINR,
} from './overlap.constants';
import styles from './OverlapTooltipContent.module.scss';

interface Props {
    row: OverlapRow;
    tabConfig?: OverlapTabConfig;
    unitDivisor?: number;
}

function OverlapTooltipContent({ row, tabConfig = OVERLAP_TAB_CONFIG.revenue, unitDivisor = 1 }: Props) {
    // Keyed off the row's DISPLAYED own-side total (tabConfig.totalKey), matching the Total and
    // Net cells — circularTotal is max(own, other) upstream, which for a party we transact more
    // with on the other side showed a "Total" (and Net) larger than the row itself. circularValue
    // = min(own, other) ≤ own total, so the % here is always ≤ 100.
    const { totalKey, ownLabel, otherLabel } = tabConfig;
    const ownTotal = row[totalKey] as string | undefined;
    const { circularValue, circularTotal } = row;

    const totalNum = parseINR(ownTotal);
    const circularNum = parseINR(circularValue);
    const circularPctNum = ownTotal && circularValue && totalNum ? (circularNum / totalNum) * 100 : NaN;

    const netValue = ownTotal && circularValue ? formatAmountInUnit(totalNum - circularNum, unitDivisor) : '-';

    return (
        <div className={styles.Container}>
            <p className={styles.Title}>Circular Transaction Detected</p>

            <div className={styles.Rows}>
                <div className={styles.Row}>
                    <span className={styles.Label}>Total {ownLabel}</span>
                    <span className={styles.ValueDefault}>{(scaleINR(ownTotal, unitDivisor) as string) || '-'}</span>
                </div>

                {circularTotal && (
                    <div className={styles.Row}>
                        <span className={styles.Label}>Total {otherLabel}</span>
                        <span className={styles.ValueDefault}>{scaleINR(counterpartTotal(row, totalKey), unitDivisor) as string}</span>
                    </div>
                )}

                {circularValue && (
                    <div className={styles.Row}>
                        <span className={styles.Label}>Circular{!isNaN(circularPctNum) ? ` (${circularPctNum.toFixed(1)}%)` : ''}</span>
                        <span className={styles.ValueRed}>{scaleINR(circularValue, unitDivisor) as string}</span>
                    </div>
                )}

                <div className={styles.Divider} />

                <div className={styles.Row}>
                    <span className={styles.Label}>Net {ownLabel}</span>
                    <span className={styles.ValueBold}>{netValue}</span>
                </div>
            </div>
        </div>
    );
}

export default OverlapTooltipContent;
